import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import InViewMonitor from 'react-inview-monitor'
import easing from 'ui/styles/easing'

const Wrapper = styled.div`
  margin-bottom: 30px;
  transform: ${props => props.inView ? 'translateY(0px)' : 'translateY(30px)'};
  opacity: ${props => props.inView ? 1 : 0};
  transition: transform 0.6s ${easing.easeOutCubic}, opacity 0.6s ${easing.easeOutCubic};
`

const ImageEl = styled.img`
  width: 100%;
  display: block;
`

export default class Image extends Component {
  render() {
    const { image } = this.props
  
    return(
      <InViewMonitor childPropsInView={{inView: true}}>
        <Wrapper>
          <Container fluid>
            <Row>
              <Col
                sm={9}
                smOffset={1}
                lgOffset={2}
              >
                <ImageEl
                  src={image.sourceUrl}
                  alt=""
                />
              </Col>
            </Row>
          </Container>
        </Wrapper>
      </InViewMonitor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Image/index.js